module.exports = __webpack_public_path__ + "static/media/signage-outdoor-img12.a7b761f2.jpg";